import { API } from '@shared/types/api';
import { Action } from '@shared/util/context';

export interface State {
  selectedCards: API.CardFragment[];
  active: boolean;
}

type Actions =
  | Action<'addCard', { args: API.CardFragment }>
  | Action<'removeCard', { args: API.CardFragment }>
  | Action<'removeCardById', { args: { id: string } }>
  | Action<'setActive', { args: boolean }>
  | Action<'reset'>;

export const initialState: State = {
  selectedCards: [],
  active: false,
};

export function reducer(state: State, action: Actions): State {
  switch (action.type) {
    case 'addCard': {
      const card = action.args;
      const selectedCards = [...state.selectedCards, card];
      return {
        ...state,
        selectedCards,
      };
    }
    case 'removeCardById':
    case 'removeCard': {
      const cardId = action.args.id;
      const selectedCards = state.selectedCards.filter(({ id }) => id !== cardId);
      return {
        ...state,
        selectedCards,
      };
    }
    case 'setActive': {
      const active = action.args;
      return {
        ...state,
        active,
      };
    }
    case 'reset': {
      return initialState;
    }
  }
}
